function formatNumber(num) {
  if (num >= 1000000) {
    return `${(num / 1000000).toFixed(2).replace(/\.?0+$/, '')}M`
  }

  if (num >= 1000) {
    return `${(num / 1000).toFixed(2).replace(/\.?0+$/, '')}k`
  }

  return num.toString()
}

export default formatNumber
